export var Events;
(function (Events) {
    // receive
    Events["DO_LOGOUT"] = "DO_LOGOUT";
    Events["INIT_FORGE_DATA"] = "INIT_FORGE_DATA";
    Events["INIT_EXTEND_SESSION"] = "INIT_EXTEND_SESSION";
    // propagate
    Events["PROPAGATE_OPEN_MODAL"] = "PROPAGATE_OPEN_MODAL";
    Events["PROPAGATE_FORGE_TOKEN_UPDATED"] = "PROPAGATE_FORGE_TOKEN_UPDATED";
    Events["PROPAGATE_CLOSE_MODAL"] = "PROPAGATE_CLOSE_MODAL";
    Events["PROPAGATE_LOGOUT"] = "PROPAGATE_LOGOUT";
    Events["PROPAGATE_SESSION_FINISH_TIME"] = "PROPAGATE_SESSION_FINISH_TIME";
    // AUTH0
    Events["INIT_AUTH0_DATA"] = "INIT_AUTH0_DATA";
    // FORGE
    Events["PROPAGATE_AUTH0_TOKEN_UPDATED"] = "PROPAGATE_AUTH0_TOKEN_UPDATED";
})(Events || (Events = {}));
